import React from 'react';

import type { NextPageWithLayout } from 'nextjs/types';

import PageNextJs from 'nextjs/PageNextJs';

import config from 'configs/app';
import SabaHome from 'ui/home/saba/SabaHome';
import HomeOpSuperchain from 'ui/optimismSuperchain/home/HomeOpSuperchain';
import LayoutHome from 'ui/shared/layout/LayoutHome';

const Page: NextPageWithLayout = () => {
  return (
    <PageNextJs pathname="/">
      { config.features.opSuperchain.isEnabled ? <HomeOpSuperchain/> : <SabaHome/> }
    </PageNextJs>
  );
};

Page.getLayout = function getLayout(page: React.ReactElement) {
  if (!config.features.opSuperchain.isEnabled) {
    return page;
  }
  return (
    <LayoutHome>
      { page }
    </LayoutHome>
  );
};

export default Page;

export { base as getServerSideProps } from 'nextjs/getServerSideProps';
